<template>
  <VeeForm ref="form" @submit="onSubmit">
    <h2 class="step-title-optional">
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@ADDRESS_TITLE")) }}
    </h2>

    <ExtraTipbox class="margin-15 font-090">
      <span>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@ADDRESS_TIPS") }}</span>
    </ExtraTipbox>

    <section class="q-mx-md">
      <AddressFormComponent v-model:street="street" v-model:city="city" v-model:zipcode="zipcode" />
    </section>
    <transition appear enter-active-class="animated fadeIn slower delay-1s" leave-active-class="animated fadeOut">
      <section class="q-footer q-layout__section--marginal fixed-bottom">
        <div>
          <QBtn
            color="secondary"
            class="full-width btn-navigation"
            :label="$t('ETAB.BUTTONS.@NEXT')"
            no-caps
            type="submit"
            :disabled="submitting"
            :loading="loading"
          />
        </div>
      </section>
    </transition>
  </VeeForm>
</template>

<script>
  import { CreationStepAddressModel, ICreationStepAddress } from "@core/models";
  import { ScrollManager } from "@core/managers/scroll.manager";
  import { SanitationHelper } from "@core/helpers";

  import AddressFormComponent from "@etab/components/creation/Address.form.component.vue";
  import { Form as VeeForm } from "vee-validate";

  export default {
    components: {
      AddressFormComponent,
      VeeForm,
    },
    props: {
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
      stepAssets: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        submitting: false,
        street: null,
        city: null,
        zipcode: null,
      };
    },
    computed: {
      stepDataModel() {
        return new CreationStepAddressModel(this.stepData);
      },
      stepAssetsModel() {
        return new CreationStepAddressModel(this.stepAssets);
      },
      missionAddress() {
        return Object.keys(this.stepData).length ? this.stepDataModel : this.stepAssetsModel;
      },
    },
    created() {
      this.initAddress();
      ScrollManager.scrollToTop();
    },
    methods: {
      initAddress() {
        this.street = this.missionAddress.getStreet();
        this.city = this.missionAddress.getCity();
        this.zipcode = this.missionAddress.getZipcode();
      },
      onSubmit() {
        this.save({
          [ICreationStepAddress.street]: this.street,
          [ICreationStepAddress.city]: SanitationHelper.sanitizeCityName(this.city),
          [ICreationStepAddress.zipcode]: this.zipcode,
        });
      },
      save(address) {
        this.submitting = true;
        this.$emit("saveStep", address);
        setTimeout(() => {
          this.submitting = false;
        }, 1000);
      },
    },
  };
</script>
